/* global axios */
// FLOW-11 (SPEC S4, R9 e Q5) — o cofre de segredos da conta, de onde o `secret('nome')` de um flow da
// conta resolve. Usa o axios global (carrega os headers de sessão).
//
// O VALOR só vai ao servidor, nunca volta: as respostas têm o nome, quem gravou e quando. Ele viaja no
// campo `secret`, que o log de requisição do servidor filtra. Não existe método de leitura de valor
// porque não existe rota.
//
// FLOW-13 (S1, Q5; PLAN G1, G3, G4): o cofre passa a ser do gestor da conta com a flag PowerAgents, sem
// depender da chave do PowerFlow (quem decide é o servidor; a porta da frente é o `useGestorDoCofre`).
// O `index` traz o "Usado por" de cada segredo, e o `conferir` diz quais agentes ainda guardam um
// valor próprio com o nome, para o aviso do "Novo segredo". Os dois respondem só nomes.
const BASE = accountId => `/api/v1/accounts/${accountId}/flow_secrets`;

const body = r => r.data;

// O "Usado por" chega como `usado_por: [{tipo, id, nome, agente}]`, com `tipo` em `ferramenta_http`,
// `flow` ou `legada`, e `agente` nulo quando a ferramenta não está ligada a nenhum. Sem o campo (o
// servidor de antes do S1), a lista sai vazia, e a tela diz "Sem uso" em vez de quebrar.
const comUso = segredo => ({
  ...segredo,
  usado_por: Array.isArray(segredo?.usado_por) ? segredo.usado_por : [],
});

export default {
  index(accountId) {
    return axios
      .get(BASE(accountId))
      .then(r => (r.data?.payload || []).map(comUso));
  },

  // FLOW-13 (G4): os agentes da conta (`bot_name`) que guardam um valor próprio para `nome`. O nome
  // vai na query pelo axios, que o codifica; a resposta é `{agentes: [...]}`, e sai só a lista.
  conferir(accountId, nome) {
    return axios
      .get(`${BASE(accountId)}/conferir`, { params: { name: nome } })
      .then(r => (Array.isArray(r.data?.agentes) ? r.data.agentes : []));
  },

  // FLOW-13 (S3, Q3; §6 do PLAN, itens 5 e 6; tela 5 do mockup): os nomes que ficaram nos agentes,
  // só para o super-admin (os outros recebem 403 `ficaram_nos_agentes_requires_super_admin`). Cada
  // item: `{nome, categoria, agentes: [{id, nome}], motivo, decisao, usado_por}`, com a `categoria` em
  // `colisao`, `conflito_com_o_cofre`, `fica_no_agente` ou `nome_fora_da_regra`, nessa ordem. O
  // `motivo` e a `decisao` vêm prontos do servidor. Só nomes.
  ficaramNosAgentes(accountId) {
    return axios.get(`${BASE(accountId)}/ficaram_nos_agentes`).then(r =>
      (Array.isArray(r.data?.payload) ? r.data.payload : [])
        .filter(item => item && typeof item.nome === 'string')
        .map(item => ({
          nome: item.nome,
          categoria: String(item.categoria || ''),
          agentes: Array.isArray(item.agentes) ? item.agentes : [],
          motivo: String(item.motivo || ''),
          decisao: String(item.decisao || ''),
          usado_por: Array.isArray(item.usado_por) ? item.usado_por : [],
        }))
    );
  },

  // `{ name, secret }`. O nome segue a regra do `secret('nome')`.
  create(accountId, { name, secret }) {
    return axios.post(BASE(accountId), { name, secret }).then(body);
  },

  // "Trocar valor": só o valor novo. O nome não muda, porque o flow o lê por ele.
  update(accountId, id, { secret }) {
    return axios.patch(`${BASE(accountId)}/${id}`, { secret }).then(body);
  },

  destroy(accountId, id) {
    return axios.delete(`${BASE(accountId)}/${id}`).then(body);
  },
};
